export default {
	name: 'customersPayMoney',
	data() {
		return {
			timeType: '0',
			vipLevl: '',
			CustomerID: 0,
			CustomerPhone: '',
			CustomerName: '',
			VipBeginDate: '',
			VipEndDate: '',
			VipLevlID: 1,
			Disbursements: 0,
			Deposit: 0,
			VipLevlIDIndex: 0,
			OperatorID: this.$store.state.user.UserID,
			clear: {},
			remarks: '',
			boxMoney: 0,
			boxMoney1: 0,
			CustomerChild: 1,
			CustomerState: 1,
			BelongTo: '杨婕',
			age: 0,
			school: '',

			state: [{
				id: 1,
				text: '正常'
			}, {
				id: 2,
				text: '暂停'
			}, {
				id: 3,
				text: '停止'
			}]
		};
	},
	created() {
		this.clear = function() {
			this.CustomerID = 0;
			this.CustomerName = "";
			this.remarks = "";
			this.Disbursements = 0;
			this.Deposit = 0;
			this.CustomerPhone = "";
			this.VipEndDate = "";
			this.VipEndDate = "";
			this.boxMoney = 0;
			this.CustomerChild = 1;
			this.age = 0;
			this.school = "";
			this.CustomerState = 1;
			this.boxMoney1 = 0;
			this.BelongTo='杨婕';
		};
		this.$request.request({
			url: 'Customer/getVipLevl',
			data: {},
			method: 'post'
		}).then(res => {
			if (res.result) {
				this.vipLevl = res.vipLevl;
			}
		});

	},
	methods: {
		editCustomer() {
			this.$request.request({
				url: 'Customer/vipRenewal',
				data: {
					CustomerState: this.CustomerState,
					CustomerPhone: this.CustomerPhone,
					CustomerID: this.CustomerID,
					VipLevlID: this.VipLevlID,
					Disbursements: this.Disbursements,
					remarks: this.remarks,
					OperatorID: this.OperatorID,
					VipBeginDate: this.VipBeginDate,
					VipEndDate: this.VipEndDate,
					CustomerName: this.CustomerName,
					school: this.school,
					boxMoney: this.boxMoney,
					CustomerChild: this.CustomerChild,
					age: this.age,
					BelongTo: this.BelongTo
				},
				method: 'post'
			}).then(res => {
				this.$uil.showMessage({
					text: res.message
				});
			});
		},
		searchCustomers(e) {
			if (e.keyCode == 13 && this.CustomerPhone.length >= 11) {
				this.$request.request({
					url: 'Customer/getCustomerByCustomerCode',
					data: {
						searchText: this.CustomerPhone
					},
					method: 'post'
				}).then(res => {

					if (res.result) {
						this.CustomerState = res.customer.CustomerState;
						this.CustomerPhone = res.customer.CustomerPhone;
						this.CustomerName = res.customer.CustomerName;
						this.Deposit = res.customer.Deposit;
						this.CustomerID = res.customer.CustomerID;
						this.VipBeginDate = res.customer.VipBeginDate;
						this.VipEndDate = res.customer.VipEndDate;
						this.VipLevlID = res.customer.VipLevlID;
						this.boxMoney1 = res.customer.boxMoney;
						this.age = res.customer.age;
						this.CustomerChild = res.customer.CustomerChild;
						this.school = res.customer.school;
						this.BelongTo = res.customer.BelongTo;
					}

				});
			}
		}
	},
	computed: {
		checkDate() {
			if (this.CustomerName == "") return true;
			//if (this.Disbursements == 0 && this.remarks == '') return true;
			if (this.VipBeginDate == '' || this.VipEndDate == "") return true;
			let begin = new Date(this.VipBeginDate.replace(/-/g, '/'));
			let end = new Date(this.VipEndDate.replace(/-/g, '/'));
			if (begin >= end)
				return true;
			else
				return false;
		}
	},
	filters: {
		rmb(v) {
			return v + '¥';
		}
	}
}
